import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-temp-registraion',
  templateUrl: './home-temp-registraion.component.html',
  styleUrls: ['./home-temp-registraion.component.css']
})
export class HomeTempRegistraionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/home/home-temp-registraion/home-temp-registraion.component.ts